// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const userApi = baseApi.injectEndpoints({
  reducerPath: "userApi",
  endpoints: (builder) => ({
    updateUser: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `admin/block-user/${modifiedData}`,
          method: "POST",
          // body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    removeBlockUser: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/unblock-user/${slug}`,
          method: "POST",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getAllDispatchers: builder.query({
      query: ({ search = '', limit, page }) => {
        return {
          url: `admin/dispatchers?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllOfficers: builder.query({
      query: ({ search = '', limit, page }) => {
        return {
          url: `admin/officers?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    addUser: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `admin/create-user`,
          method: "POST",
          body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    userUpdate: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `admin/update-user/${modifiedData?.id}`,
          method: "PATCH",
          body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUpdateUserMutation,
  useRemoveBlockUserMutation,
  useGetAllDispatchersQuery,
  useGetAllOfficersQuery,
  useAddUserMutation,
  useUserUpdateMutation,
} = userApi;
